// Same colors as platform, so no override
const posterColors = {};

export default posterColors;
